export const getHeaders = () => {
  return {
    "Content-Type": "application/json",
    "X-CSRF-Token": document
      .querySelector("meta[name='csrf-token']")
      .getAttribute("content"),
  };
};
